import { ISidebarState } from './types'

const state: ISidebarState = {
    isSidebarOpen: false,
    isSettingsPanelOpen: false,
    isWhatsNewPanelOpen: false,
    isHelpPanelOpen: false,
    enableHelpPanel: false,
}

export default state

